import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivableComment.List.IRequest;
type Response = Api.Finance.AccountReceivableComment.List.IResponse;
type Headers = Api.Finance.AccountReceivableComment.List.IHeaders;
const url = '/api/Finance/AccountReceivableComment';
export default async function accountReceivableCommentListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}

